<template>
    <div class="editor">
        <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
            <div class="menubar">
                <button class="menubar__button" :class="{ 'is-active': isActive.bold() }" @click="commands.bold">
                    <b>B</b>
                </button>
                <button class="menubar__button" :class="{ 'is-active': isActive.italic() }" @click="commands.italic">
                    <i>i</i>
                </button>
                <button class="menubar__button" :class="{ 'is-active': isActive.strike() }" @click="commands.strike">
                    <s>S</s>
                </button>
                <button class="menubar__button" :class="{ 'is-active': isActive.underline() }" @click="commands.underline">
                    <u>U</u>
                </button>
                <button class="menubar__button" :class="{ 'is-active': isActive.paragraph() }" @click="commands.paragraph">
                    ¶
                </button>
                <button class="menubar__button" :class="{ 'is-active': isActive.heading({ level: 1 }) }" @click="commands.heading({ level: 1 })">
                    H1
                </button>
                <button class="menubar__button" :class="{ 'is-active': isActive.heading({ level: 2 }) }" @click="commands.heading({ level: 2 })">
                    H2
                </button>
                <button class="menubar__button" :class="{ 'is-active': isActive.heading({ level: 3 }) }" @click="commands.heading({ level: 3 })">
                    H3
                </button>
                <button class="menubar__button" :class="{ 'is-active': isActive.heading({ level: 4 }) }" @click="commands.heading({ level: 4 })">
                    H4
                </button>
                <button class="menubar__button" :class="{ 'is-active': isActive.heading({ level: 5 }) }" @click="commands.heading({ level: 4 })">
                    H5
                </button>
                <button class="menubar__button" :class="{ 'is-active': isActive.bullet_list() }" @click="commands.bullet_list">
                    &equiv;
                </button>
                <button class="menubar__button" @click="commands.horizontal_rule">
                    hr
                </button>
                <button class="menubar__button" @click="showImagePrompt(commands.image)">
                    <font-awesome-icon :icon="['far', 'image']" size="sm" />
                </button>
            </div>
        </editor-menu-bar>
        <editor-content class="editor__content" :editor="editor" />
    </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
    Blockquote,
    Bold,
    BulletList,
    HardBreak,
    Heading,
    HorizontalRule,
    Image,
    Italic,
    Link,
    ListItem,
    Strike,
    Underline
} from 'tiptap-extensions'
import {
    UploadService
} from '@/common/api.service'

export default {
    components: {
        EditorContent,
        EditorMenuBar
    },
    props: ['value'],
    data () {
        return {
            editor: new Editor({
                extensions: [
                    new Blockquote(),
                    new Bold(),
                    new BulletList(),
                    new HardBreak(),
                    new Heading({ levels: [1, 2, 3, 4, 5] }),
                    new HorizontalRule(),
                    new Image(),
                    new Italic(),
                    new Link(),
                    new ListItem(),
                    new Strike(),
                    new Underline()
                ],
                onUpdate: ({ getHTML }) => {
                    const state = getHTML()
                    this.$emit('input', state)
                }
            })
        }
    },
    methods: {
        showImagePrompt (command) {
            var x = document.createElement('input')
            x.setAttribute('type', 'file')
            x.style.visibility = 'hidden'
            document.body.appendChild(x)
            x.click()
            x.onchange = function () {
                let formData = new FormData()
                formData.append('file', x.files[0])
                UploadService.upload(formData)
                    .then((
                        result
                    ) => {
                        x.remove()
                        let src = result.data[0]
                        if (src !== null) {
                            command({ src })
                        }
                    })
            }
        }
    },
    beforeDestroy () {
        this.editor.destroy()
    },
    mounted () {
        this.editor.setContent(this.value)
    }
}
</script>
<style lang="scss">
.editor {
    .menubar {
        button {
            background: none;
            border: none;
            &.is-active {
                background: #c0c0c0;
            }
        }
    }
    .editor__content {
        padding: 15px;
        background-color: #f4f4f4;
        border: 1px solid #e0e0e0;
        margin-top: 20px;
        p {
            margin-bottom: 5px;
        }
        img {
            max-width: 100%;
        }
        > div {
            &:focus {
                outline: none;
            }
        }
        .ProseMirror-selectednode {
            opacity: .8;
        }
    }
}
</style>
